import React, { Fragment } from 'react';

import Avatar from '@atlaskit/avatar';

import {
  TableCellMobileHidden,
  TableCellMobileOnly,
} from 'src/components/pageable-table';
import { Project } from 'src/components/types';
import { Link } from 'src/router/components';

import * as styles from './workspace-projects.styles';

type Props = {
  project: Project;
};

const ProjectRow = (props: Props) => {
  const { project } = props;
  const { name } = project;
  const projectLink =
    project && project.links ? project.links.html.href : undefined;
  const avatarLink =
    project && project.links ? project.links.avatar.href : undefined;

  const renderDesktopRows = () => {
    return (
      <Fragment>
        <TableCellMobileHidden widthWithUnit="25%">
          <styles.ProjectDetailContainer>
            <Link to={projectLink}>
              <Avatar
                size="small"
                appearance="square"
                name={name}
                src={avatarLink}
                status={project.is_private ? 'locked' : null}
              />
            </Link>
            <styles.ProjectName>
              <Link to={projectLink}>{name}</Link>
            </styles.ProjectName>
          </styles.ProjectDetailContainer>
        </TableCellMobileHidden>
        <TableCellMobileHidden widthWithUnit="25%">
          {project.key}
        </TableCellMobileHidden>
        <TableCellMobileHidden widthWithUnit="50%">
          {project.description}
        </TableCellMobileHidden>
      </Fragment>
    );
  };

  const renderMobileRows = () => {
    return (
      <Fragment>
        <TableCellMobileOnly widthWithUnit="40%">
          <styles.ProjectDetailContainer>
            <Link to={projectLink}>
              <Avatar
                size="small"
                appearance="square"
                name={name}
                src={avatarLink}
                status={project.is_private ? 'locked' : null}
              />
            </Link>
            <styles.ProjectName>
              <Link to={projectLink}>{name}</Link>
            </styles.ProjectName>
          </styles.ProjectDetailContainer>
        </TableCellMobileOnly>
        <TableCellMobileOnly widthWithUnit="60%">
          {project.description}
        </TableCellMobileOnly>
      </Fragment>
    );
  };

  return (
    <styles.ProjectRow data-testid="project-row">
      {renderDesktopRows()}
      {renderMobileRows()}
    </styles.ProjectRow>
  );
};
export default ProjectRow;
